if (!customElements.get('media-coverflow-gallery')) {
  customElements.define(
    'media-coverflow-gallery',
    class MediaCoverflowGallery extends HTMLElement {
      connectedCallback() {
        this.swiperEl = this.querySelector('.mcg__swiper');
        this.boundInit = this.init.bind(this);
        this.boundSectionLoad = this.handleSectionLoad.bind(this);
        document.addEventListener('shopify:section:load', this.boundSectionLoad);
        this.boundInit();
      }

      handleSectionLoad(event) {
        if (event.target.contains(this)) this.boundInit();
      }

      init() {
        if (!this.swiperEl) return;

        if (typeof Swiper === 'undefined') {
          if (!this.retriedSwiperLoad) {
            this.retriedSwiperLoad = true;
            document.addEventListener('DOMContentLoaded', this.boundInit, { once: true });
            window.addEventListener('load', this.boundInit, { once: true });
          }
          return;
        }

        if (this.swiperEl.swiper) {
          this.swiperEl.swiper.destroy(true, true);
        }

        const data = this.dataset;
        const slidesPerViewMobile = parseInt(data.spMobile, 10) || 1;
        const slidesPerViewTablet = parseInt(data.spTablet, 10) || 3;
        const slidesPerViewDesktop = parseInt(data.spDesktop, 10) || 3;

        this.swiper = new Swiper(this.swiperEl, {
          effect: 'coverflow',
          grabCursor: true,
          centeredSlides: true,
          slideToClickedSlide: true,
          loop: data.loop === 'true',
          slidesPerView: slidesPerViewMobile,
          spaceBetween: 16,
          coverflowEffect: {
            rotate: parseInt(data.rotate, 10) || -10,
            stretch: parseInt(data.stretch, 10) || 10,
            depth: parseInt(data.depth, 10) || 100,
            modifier: 1,
            slideShadows: data.shadows === 'true',
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          pagination: {
            el: this.swiperEl.querySelector('.mcg__pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: this.swiperEl.querySelector('.mcg__nav--next'),
            prevEl: this.swiperEl.querySelector('.mcg__nav--prev'),
          },
          autoplay: data.autoplay === 'true'
            ? { delay: parseInt(data.autoplaySpeed, 10) || 4000, disableOnInteraction: false }
            : false,
          breakpoints: {
            640: {
              slidesPerView: slidesPerViewTablet,
              spaceBetween: 20,
            },
            990: {
              slidesPerView: slidesPerViewDesktop,
              spaceBetween: 20,
            },
          },
        });
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:section:load', this.boundSectionLoad);
        if (this.swiper) this.swiper.destroy(true, true);
      }
    }
  );
}
